import { MarketplaceIntelligenceBaseApiClient } from '../marketplace-intelligence/client';
import type {
  PanelCompareJobStarted,
  PanelCompareJobVariables,
  PanelMembersResponse,
  PanelRun
} from '@interfaces/Panel.interface';

export class ApiPanel extends MarketplaceIntelligenceBaseApiClient {
  getMembers(product = 'commercial'): Promise<PanelMembersResponse> {
    return this.get<PanelMembersResponse>('/api/v1/panel/members', {
      params: { product }
    });
  }

  /** Starts a comparison job; answers at once with a run id to poll. */
  startCompare({
    persona,
    product = 'commercial',
    persona_ref
  }: PanelCompareJobVariables): Promise<PanelCompareJobStarted> {
    return this.post<PanelCompareJobStarted>(
      '/api/v1/panel/compare-jobs',
      persona,
      {
        params: { product, ...(persona_ref ? { persona_ref } : {}) }
      }
    );
  }

  /** The run so far: insurer lines that have answered, and the comparison once complete. */
  getCompareRun(runId: string): Promise<PanelRun> {
    return this.get<PanelRun>(
      `/api/v1/panel/compare-jobs/${encodeURIComponent(runId)}`
    );
  }
}

export { panelQueryKeys } from './query-keys';
export * from './use-panel-queries';
export * from './use-panel-mutations';
export { ApiPanel as PanelApi };
